import { UseQueryResult } from "@tanstack/react-query";

import { useStabilized } from "@examspark/common-ui";

export function useStabilizedQueries<TData = unknown, TError = unknown>(
  queries: Array<UseQueryResult<TData, TError>>,
  deps: any[] = [],
) {
  //
  // @todo would be nice if we could somehow get ahold of the querykeys for the passed queries,
  // and invalidate based on those
  //

  const anyQueriesFetching = queries
    .map((q) => q.isFetching)
    .reduce((prev, current) => prev || current, false);

  deps.push(anyQueriesFetching, queries.length);

  return useStabilized(queries, deps);
}
